"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useOutsideClickHandler = _interopRequireDefault(require("../../hooks/useOutsideClickHandler"));

var _HomeSvg = _interopRequireDefault(require("../../assets/HomeSvg"));

var _AmbassadorDashboardSvg = _interopRequireDefault(require("../../assets/AmbassadorDashboardSvg"));

var _LogoutSvg = _interopRequireDefault(require("../../assets/LogoutSvg"));

var _styled = require("./styled");

var _HideButton = _interopRequireDefault(require("./HideButton"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _links = require("../links");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DesktopNavigation = function DesktopNavigation(_ref) {
  var pageType = _ref.pageType,
      logOutUser = _ref.logOutUser,
      user = _ref.user,
      isInitInProgress = _ref.isInitInProgress,
      mainSiteUrl = _ref.mainSiteUrl,
      showLogin = _ref.showLogin,
      isVisible = _ref.isVisible,
      isToggleable = _ref.isToggleable,
      setIsVisible = _ref.setIsVisible,
      avatarElement = _ref.avatarElement,
      enableRemoteDoctor = _ref.enableRemoteDoctor,
      children = _ref.children;
  var navbarRef = (0, _react.useRef)(null);
  var links = (0, _links.getLinks)(mainSiteUrl, enableRemoteDoctor);
  var isRemoteHealth = pageType.isRemoteHealth,
      isNomadInsurance = pageType.isNomadInsurance,
      isNomadHealth = pageType.isNomadHealth,
      isRemoteDoctor = pageType.isRemoteDoctor,
      isHomepage = pageType.isHomepage,
      isGlobal = pageType.isGlobal; // close navbar on click outside of it, except on home page and global pages

  (0, _useOutsideClickHandler.default)(navbarRef, function () {
    if (!isHomepage && !isGlobal) {
      setIsVisible(false);
    }
  });

  var hasActiveProducts = function hasActiveProducts() {
    if (!user) return false;
    var hasCompletedNI = user.hasCompletedNI,
        hasCompletedRH = user.hasCompletedRH,
        isCompanyMember = user.isCompanyMember,
        isCompanyAdmin = user.isCompanyAdmin,
        isCompanyOwner = user.isCompanyOwner;
    return hasCompletedNI || isCompanyAdmin || isCompanyOwner || hasCompletedRH && isCompanyMember || hasCompletedRH && !isCompanyMember;
  };

  var profileItems = function profileItems() {
    var items = [{
      label: "Go to profile",
      url: "/profile",
      icon: /*#__PURE__*/_react.default.createElement(_HomeSvg.default, null)
    }, {
      label: "Log out",
      onClick: function onClick() {
        return logOutUser && logOutUser();
      },
      color: "red",
      icon: /*#__PURE__*/_react.default.createElement(_LogoutSvg.default, null),
      hoverColor: "darkRed"
    }];

    if (user !== null && user !== void 0 && user.isAmbassador) {
      items.splice(1, 0, {
        label: "Ambassador dashboard",
        url: "/ambassador/dashboard",
        icon: /*#__PURE__*/_react.default.createElement(_AmbassadorDashboardSvg.default, null)
      });
    }

    return items;
  };

  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    isVisible: isVisible
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: navbarRef
  }, /*#__PURE__*/_react.default.createElement(_styled.Navbar, {
    isVisible: isVisible
  }, /*#__PURE__*/_react.default.createElement(_styled.Logo, {
    onClick: function onClick() {
      if (typeof window !== "undefined") {
        window.location.href = mainSiteUrl;
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_styled.StyledProductMenu, {
    isVisible: isVisible,
    disabled: !isVisible,
    products: links.products
  }), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    label: "Tools",
    disabled: !isVisible,
    size: "large",
    items: links.tools
  }), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    label: "About us",
    labelColor: "white",
    variant: "dark",
    items: links.about,
    disabled: !isVisible
  }), /*#__PURE__*/_react.default.createElement(_styled.RightAlignButtons, {
    isVisible: isVisible
  }, !(user !== null && user !== void 0 && user.isAuthenticated) && !isInitInProgress && showLogin && /*#__PURE__*/_react.default.createElement(_styled.LoginButton, {
    onClick: function onClick() {
      return (0, _helpers.navigateToLogin)(mainSiteUrl, isRemoteHealth, isNomadHealth, isNomadInsurance, isRemoteDoctor);
    }
  }, "Log in"), (user === null || user === void 0 ? void 0 : user.isAuthenticated) && /*#__PURE__*/_react.default.createElement(_styled.ProfileMenu, {
    label: hasActiveProducts() && (user !== null && user !== void 0 && user.firstName || user !== null && user !== void 0 && user.lastName) ? "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName) : "My profile",
    variant: "dark",
    position: "left",
    disabled: !isVisible,
    showAvatar: hasActiveProducts(),
    avatarElement: avatarElement,
    items: profileItems()
  })), /*#__PURE__*/_react.default.createElement(_HideButton.default, {
    isToggleable: isToggleable,
    isNavVisible: isVisible,
    onClick: function onClick() {
      return setIsVisible(!isVisible);
    }
  }))), children && _react.default.Children.map(children, function (child) {
    if (!child) return null;
    return /*#__PURE__*/_react.default.cloneElement(child, {
      className: "navbar-child"
    });
  }));
};

DesktopNavigation.propTypes = {
  pageType: _propTypes.default.object,
  logOutUser: _propTypes.default.func,
  user: _propTypes.default.object,
  isInitInProgress: _propTypes.default.bool,
  mainSiteUrl: _propTypes.default.string,
  showLogin: _propTypes.default.bool,
  isVisible: _propTypes.default.bool,
  isToggleable: _propTypes.default.bool,
  setIsVisible: _propTypes.default.func,
  avatarElement: _propTypes.default.node,
  enableRemoteDoctor: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = DesktopNavigation;
exports.default = _default;